import { ValidationContext } from "~app/common/validation/validationContext";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";

export class ArbetsorderKontraktsraderValidation {
    static init(): ValidationContext {
        const context = new ValidationContext();
        context.errorLevel = ValidationErrorLevels.error;
        context.create(ValidationScopes.spara).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                id: 4,
                message: { text: "Mätemetod måste vara en siffra mellan 2 och 9. Använd - för att lämna tomt" },
                model: () => null,
                name: "Matmetod",
                expression: (value) => value === null || (value >= 2  && value <= 9) || value === "-" || value === "",
                triggerOnLoad: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 5,
                message: { text: "AL kod måste vara 8 siffror" },
                model: () => null,
                name: "AlKod",
                expression: (value) => value === "" || value === null || value.toString().length === 8,
                triggerOnLoad: true
            },
            {
                errorLevel: ValidationErrorLevels.error,
                id: 5,
                message: { text: "Kollektiv måste vara 5 tecken och börja med 0. Använd - för att lämna tomt" },
                model: () => null,
                name: "Kollektiv",
                expression: (value) => value === null || (value.toString().length === 5 && value.toString().startsWith("0")) || value === "-" || value === "",
                triggerOnLoad: true
            }
        ]);
        return context;
    }
}
